import {
  faCog, faHome, faLocationDot, faMessage,
  faSignInAlt,
  faSignOutAlt,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import {Link, useNavigate, useLocation} from "react-router-dom";
import {Notifications, Session, SettingsDoc, User} from "../types/Types";
import {getAuth, signOut} from "firebase/auth";
import UserTag from "../users/tag/UserTag";
import {isChatEnabled} from "../util/Util";
import PageTracking from "../auth/PageTracking";
import AuthCheck from "../auth/AuthCheck";

interface Props {
  session: Session | undefined;
  sessions: Array<Session> | undefined;
  notifications: Notifications | undefined;
  currentUser: User | undefined;
  setCurrentUser: (user: User | undefined) => void;
  settings: SettingsDoc | undefined;
  refreshSessions: () => Promise<void>;
}

function Header(props: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [shouldNotify, setShouldNotify] = useState(false);

  const checkNotification = (): boolean => {
    if(window.location.href.includes("chat")) {
      return false
    }
    if(props.currentUser == undefined) {
      return false
    }
    if(props.notifications == undefined || props.currentUser == undefined) {
      return false
    }
    if(props.notifications.lastMessage == undefined) {
      return false
    }
    if(props.currentUser.messageChannels == undefined) {
      return true
    }
    return props.notifications.lastMessage && props.notifications.lastMessage > props.currentUser.messageChannels.lastSeen;
  };

  useEffect(() => {
      setShouldNotify(checkNotification)
  }, [props.notifications, props.currentUser]);

  const logout = () => {
    const auth = getAuth();
    signOut(auth).then(() => {
      props.setCurrentUser(undefined);
      navigate("/");
    });
  };

  const handleActiveSessionsClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    await props.refreshSessions();
    navigate('/hub/sessions');
  };

  return (
    <>
      <PageTracking />
      <AuthCheck />
      <Navbar expand variant="dark" sticky="top" bg="dark" style={{maxHeight: "70px"}}>
        <Container>
          <div className={`logo${props.currentUser?.enableUiV2 ? " v2-logo" : ""}`}>
            <Navbar.Brand as={Link} to="/home" style={{ fontSize: "10pt", margin: "0"}}>'Spoons<br/>Tracker</Navbar.Brand>
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              {props.currentUser && (
                <Nav.Item style={{paddingTop: "7px", paddingBottom: "0px"}}>
                  <div style={{display: "flex", alignItems: "center", gap: "0px"}}>
                    {(props.currentUser && !props.currentUser.socialDisabled && props.sessions && props.sessions.length > 0) && (
                      <Link to={`/hub/sessions`} className="nav-link cursor-pointer" onClick={handleActiveSessionsClick} style={{paddingRight: "8px"}}>
                        <div className={`user-tag active-session`} style={{paddingBottom: "0px", marginBottom: 0, marginTop: "1px", marginRight: "-7px"}}>
                          <FontAwesomeIcon icon={faLocationDot} />
                          <div className={"d-inline-block ml-1"}>{props.sessions.length}</div>
                        </div>
                      </Link>
                    )}
                    <Link to={`/profile/${props.currentUser.id}`} className="nav-link cursor-pointer" style={{paddingBottom: "3px", paddingRight: "0px"}}>
                      <UserTag visit={undefined} session={props.session} user={props.currentUser} padRight={false} hideLocationDot={true} linksToTab={""} />
                    </Link>
                  </div>
                  <div style={{float: "right"}}>
                    {/*{this.props.currentUser && <div className={"d-inline-block"} style={{color: "rgba(255, 255, 255, 0.6)"}}>*/}
                    {/*    <div className={"d-inline-block mr-1"}>{this.props.currentUser.visitCount} - {this.props.currentUser.sessionVerifiedCount}<small><FontAwesomeIcon className={"ml-1"} icon={faLocationDot} /></small>*/}
                    {/*    </div>*/}
                    {/*</div>}*/}
                    {props.currentUser && (
                        <Nav.Item className={"d-inline-block"} style={{paddingTop: "0px"}}>
                          <Link to={`/home`} className="nav-link cursor-pointer" style={{paddingTop: "0px"}}>
                            <FontAwesomeIcon 
                              icon={faHome}
                              style={{color: location.pathname === '/home' ? 'white' : 'rgba(255, 255, 255, 0.6)'}}
                            />
                          </Link>
                        </Nav.Item>
                    )}
                    {props.currentUser && (
                        <Nav.Item className={"d-inline-block"} style={{paddingTop: "0px"}}>
                          <Link to={`/events`} className="nav-link cursor-pointer" style={{paddingTop: "0px"}}>
                            <FontAwesomeIcon 
                              icon={faCalendar}
                              style={{color: location.pathname === '/events' ? 'white' : 'rgba(255, 255, 255, 0.6)'}}
                            />
                          </Link>
                        </Nav.Item>
                    )}
                    {isChatEnabled(props.currentUser, props.settings) && (
                        <Nav.Item className={"d-inline-block"} style={{paddingTop: "0px"}}>
                          <Link to={`/chat/general`} className="nav-link cursor-pointer" style={{paddingTop: "0px"}}>
                            <FontAwesomeIcon
                                style={{color: (shouldNotify || location.pathname.startsWith('/chat')) ? "white" : "rgba(255, 255, 255, 0.6)"}}
                                icon={faMessage}
                            />
                          </Link>
                        </Nav.Item>
                    )}
                    {props.currentUser && (
                        <Nav.Item className={"d-inline-block"} style={{paddingTop: "0px"}}>
                          <Link to={`/settings`} className="nav-link cursor-pointer" style={{paddingTop: "0px"}}>
                            <FontAwesomeIcon 
                              icon={faCog}
                              style={{color: location.pathname === '/settings' ? 'white' : 'rgba(255, 255, 255, 0.6)'}}
                            />
                          </Link>
                        </Nav.Item>
                    )}
                    {props.currentUser && (
                        <Nav.Item className={"d-inline-block"} style={{paddingTop: "0px"}}>
                          <Button
                              onClick={logout}
                              className="nav-link"
                              variant="link"
                              style={{paddingTop: "0px"}}
                          >
                            <FontAwesomeIcon icon={faSignOutAlt} />
                          </Button>
                        </Nav.Item>
                    )}
                  </div>
                </Nav.Item>
              )}
              {!props.currentUser && (
                <Nav.Item>
                  <Link to="/" className="nav-link">
                    Login <FontAwesomeIcon icon={faSignInAlt} />
                  </Link>
                </Nav.Item>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
